<script setup>
import { computed } from 'vue';
import { useFlagStore } from '@/store';
defineOptions({
  name: 'LoadingElement'
});
const store = useFlagStore();
const isLoading = computed(() => store.isLoading);
</script>
<template>
  <div v-if="isLoading" id="loading"></div>
</template>
<style>
/* spinnertje icon-spin1 */
#loading {
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: fixed;
  opacity: 0.7;
  z-index: 99;
  text-align: center;
  background: #fff url(@/assets/loading.gif) no-repeat center;
  .active *,
  .inactive * {
    transition: opacity 1s ease-out;
  }
}
</style>
